import { Pipe, PipeTransform } from "@angular/core";
import { ReportDto, SurveyFieldDto } from "@api";

@Pipe({ name: "reportsWithQuestion" })
export class ReportsWithQuestionPipe implements PipeTransform {
  public transform(reports: ReportDto[], fields: SurveyFieldDto[]): ReportDto[] {
    return reports?.filter(report => fields.some(field => field.dataDefinitionId === report.dataDefinitionId));
  }
}
